/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  divider: {
    margin: `${theme.spacing(3)}px 0`,
  },
  card: {
    minWidth: 275,
  },
  num: {
    fontSize: 14,
    marginLeft: 5,
  },
  rightIcon: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: 150,
    height: 150,
  },
  btnArea: {
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  gutterBottom: {
    marginBottom: theme.spacing(3),
  },
  rightAction: {
    '&:not(:first-child)': {
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'center',
    },
  },
  floatingButtonWrap: {
    position: 'relative',
    paddingTop: 50,
  },
  buttonAdd: {
    position: 'absolute',
    right: 20,
    top: -20,
  },
  buttonAddList: {
    display: 'none',
    marginLeft: 10,
  },
  title: {
    fontSize: 20,
    height: 30,
    fontWeight: theme.typography.fontWeightMedium,
  },
  ratting: {
    margin: '10px 0',
    '& button': {
      width: 24,
      height: 24,
    },
  },
  status: {
    position: 'absolute',
    right: 0,
    top: 0,
    padding: 10,
    '& > *': {
      margin: 5,
    },
  },
  desc: {
    height: 45,
    overflow: 'hidden',
  },
  actions: {
    display: 'flex',
  },
  avatar: {
    boxShadow: theme.shadows[7],
  },
  avatarBig: {
    width: 80,
    height: 80,
    margin: '-56px auto 10px',
    background: theme.palette.secondary.dark,
    boxShadow: theme.shadows[7],
  },
  name: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonProfile: {
    margin: 20,
  },
  bottomLink: {
    width: '100%',
  },
  verified: {
    fontSize: 16,
    color: theme.palette.primary.main,
  },
  cardList: {
    display: 'flex',
    justifyContent: 'space-between',
    '& $buttonAddList': {
      display: 'inline-block',
    },
    '& $floatingButtonWrap': {
      flex: 1,
    },
    '& $buttonAdd': {
      display: 'none',
    },
    '& $status': {
      right: 'auto',
      left: 0,
    },
  },
  media: {
    height: 0,
    position: 'relative',
    paddingTop: '56.25%', // 16:9
    [theme.breakpoints.only('sm')]: {
      paddingTop: '26.25%',
    },
  },
  extraRounded: {},
  roundedMedia: {
    width: '92%',
    height: 200,
    borderRadius: '0px',
    margin: '4%',
    position: 'relative',
  },
  lightButton: {
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
  },
  imageButton: {
    zIndex: 1,
    position: 'relative',
    top: 0,
    bottom: 0,
    color: theme.palette.common.white,
    whiteSpace: 'normal',
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      '& h1': {
        fontSize: 32,
        lineHeight: '42px',
      },
      '& p': {
        fontSize: 16,
      },
    },
    [theme.breakpoints.only('sm')]: {
      '& h1': {
        width: '60%',
      },
    },
  },
});

export default styles;
